console.info("Supsis init");
require("./utils/session");
require("./api/hostFetcher");
require("./push-notification/windowPubSub");

import { OUTPUT_CONSOLE_VERSION } from "./utils/outputConsoleVersion";
import { WEB_PUSH_NOTIFICATION_SERVICE } from "./push-notification/subscribe";

console.log(
    "%c " + OUTPUT_CONSOLE_VERSION,
    "font-weight: bold; font-size: 50px;color: orange; text-shadow: 3px 3px 0 rgb(217,31,38) , 6px 6px 0 rgb(226,91,14) , 9px 9px 0 rgb(245,221,8) , 12px 12px 0 rgb(5,148,68) , 15px 15px 0 rgb(2,135,206) , 18px 18px 0 rgb(4,77,145) , 21px 21px 0 rgb(42,21,113)"
);

import Vue from "vue";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import BootstrapVue from "bootstrap-vue";
import VeeValidate from "vee-validate";
import VuejsDialog from "vuejs-dialog";
import VueChatScroll from "vue-chat-scroll";
import Toasted from "vue-toasted";
import wysiwyg from "vue-wysiwyg";
import Datetime from "vue-datetime";
import App from "./App";
import router from "./router";
import store from "./store";
import VueExcelXlsx from "vue-excel-xlsx";
import "./utils/filters";
import { sync } from "vuex-router-sync";
import { i18n } from "./language";
import messagesTR from "./language/validationMessagesTR";
import messagesEN from "./language/validationMessagesEN";
import messagesRU from "./language/validationMessagesRU";
import CKEditor from "@ckeditor/ckeditor5-vue";
import { garbageChatCollector } from "./workers/garbageChatCollector";
import { liveVisitorsSyncWorker } from "./workers/liveVisitorsSyncWorker";
import { conversationsSyncWorker } from "./workers/conversationsSyncWorker";
import { startTitleUpdater } from "./workers/titleUpdater";
import { liveVisitorCountReporter } from "./workers/liveVisitorCountReporter";
import { log2 } from "./utils/log2";
import rate from "vue-rate";
import "vue-rate/dist/vue-rate.css";
import vuescroll from "vuescroll";

//#region  charts
import ECharts from "vue-echarts";
import * as Sentry from "@sentry/vue";
import { Integrations } from "@sentry/tracing";
/*
import AudioVisual from 'vue-audio-visual'
Vue.use(AudioVisual)*/

Vue.component("v-chart", ECharts);

//#endregion

const log = log2("main");
sync(store, router);
log.info("process.env", process.env);
Vue.use(Datetime);
Vue.use(wysiwyg, {});
Vue.use(CKEditor);
Vue.use(VueChatScroll);
Vue.use(VuejsDialog);
Vue.use(Toasted);
Vue.use(VueExcelXlsx);
Vue.use(vuescroll);

Vue.config.productionTip = false;

Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.use(VeeValidate, {
    locale: "tr",
    fieldsBagName: "veeFields",
    dictionary: {
        tr: { messages: messagesTR.messages },
        en: { messages: messagesEN.messages },
        ru: { messages: messagesRU.messages },
    },
});
Vue.use(BootstrapVue);
Vue.use(rate);
new Vue({
    el: "#app",
    router,
    i18n,
    store,
    render: (h) => h(App),
});
garbageChatCollector();
liveVisitorsSyncWorker();
conversationsSyncWorker();
liveVisitorCountReporter();
startTitleUpdater();
startUserPermissionValidator();
import _ from "lodash";
import moment from "moment";
import { startUserPermissionValidator } from "./workers/userPermissionValidator";

Object.defineProperty(Vue.prototype, "$_", { value: _ });
Object.defineProperty(Vue.prototype, "$moment", { value: moment });

Sentry.init({
    Vue,
    dsn: "https://3625853a8bcb4edf9bd7d1226129e1e5@o1039697.ingest.sentry.io/6109915",
    integrations: [
        new Integrations.BrowserTracing({
            routingInstrumentation: Sentry.vueRouterInstrumentation(router),
            tracingOrigins: [
                "localhost",
                "*.supsis.live",
                "api.supsis.live",
                "beta-api.supsis.live",
                "socket.supsis.live",
                "beta-socket.supsis.live",
                "tablet-api-local.supsis.live/",
            ],
        }),
    ],
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
    environment: process.env.ENVIRONMENT,
    enabled: process.env.ENVIRONMENT !== "development",
    beforeSend: (event, hint) => {
        console.error(hint.originalException || hint.syntheticException);
        return event;
    },
    logErrors: true,
});
window.Sentry = Sentry;

WEB_PUSH_NOTIFICATION_SERVICE.registerServiceWorker();
